/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BrowseInputs */

const id_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telusuri`)
};

const ms_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layari`)
};

const da_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemse`)
};

const de_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsuchen`)
};

const en_us2_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse`)
};

const es_es2_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const es_mx2_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar`)
};

const fil_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-browse`)
};

const fr_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir`)
};

const it_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfoglia`)
};

const hu_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böngészés`)
};

const nl_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bladeren`)
};

const no_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bla gjennom`)
};

const pl_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj`)
};

const pt_br2_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar`)
};

const pt_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar`)
};

const ro_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigare`)
};

const fi_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selaa`)
};

const sv_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bläddra`)
};

const vi_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt`)
};

const tr_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gözat`)
};

const cs_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházet`)
};

const bg_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преглед`)
};

const ru_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const uk_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляд`)
};

const ar_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح`)
};

const hi_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्राउज़ करें`)
};

const th_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียกดู`)
};

const ja_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閲覧`)
};

const zh_cn2_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览`)
};

const zh_hant1_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瀏覽`)
};

const ko_nav_browse = /** @type {(inputs: Nav_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘러보기`)
};

/**
* | output |
* | --- |
* | "Browse" |
*
* @param {Nav_BrowseInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_browse = /** @type {((inputs?: Nav_BrowseInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BrowseInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_browse(inputs)
	if (locale === "ms") return ms_nav_browse(inputs)
	if (locale === "da") return da_nav_browse(inputs)
	if (locale === "de") return de_nav_browse(inputs)
	if (locale === "en-US") return en_us2_nav_browse(inputs)
	if (locale === "es-ES") return es_es2_nav_browse(inputs)
	if (locale === "es-MX") return es_mx2_nav_browse(inputs)
	if (locale === "fil") return fil_nav_browse(inputs)
	if (locale === "fr") return fr_nav_browse(inputs)
	if (locale === "it") return it_nav_browse(inputs)
	if (locale === "hu") return hu_nav_browse(inputs)
	if (locale === "nl") return nl_nav_browse(inputs)
	if (locale === "no") return no_nav_browse(inputs)
	if (locale === "pl") return pl_nav_browse(inputs)
	if (locale === "pt-BR") return pt_br2_nav_browse(inputs)
	if (locale === "pt") return pt_nav_browse(inputs)
	if (locale === "ro") return ro_nav_browse(inputs)
	if (locale === "fi") return fi_nav_browse(inputs)
	if (locale === "sv") return sv_nav_browse(inputs)
	if (locale === "vi") return vi_nav_browse(inputs)
	if (locale === "tr") return tr_nav_browse(inputs)
	if (locale === "cs") return cs_nav_browse(inputs)
	if (locale === "bg") return bg_nav_browse(inputs)
	if (locale === "ru") return ru_nav_browse(inputs)
	if (locale === "uk") return uk_nav_browse(inputs)
	if (locale === "ar") return ar_nav_browse(inputs)
	if (locale === "hi") return hi_nav_browse(inputs)
	if (locale === "th") return th_nav_browse(inputs)
	if (locale === "ja") return ja_nav_browse(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_browse(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_browse(inputs)
	return ko_nav_browse(inputs)
});
export { nav_browse as "nav.browse" }